import cuid from "cuid";

export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
export const SET_NOTIFICATION = "SET_NOTIFICATION";

const initialState = {
  notifications: []
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CLEAR_NOTIFICATION:
      return {
        notifications: state.notifications.filter((notification) => notification.id !== payload.id)
      };
    case SET_NOTIFICATION:
      return {
        notifications: [
          ...state.notifications,
          {
            cancelAction: undefined,
            cancelLabel: "",
            confirmAction: undefined,
            confirmLabel: "",
            id: cuid(),
            message: "",
            title: "",
            type: undefined,
            ...payload
          }
        ]
      };

    default:
      return state;
  }
};

export const clearNotification = (id) => ({
  type: CLEAR_NOTIFICATION,
  payload: { id }
});

/**
 * Set the Smart Notification parameters. Expect to receive an Object
 * @param {Object} params Object with the parameters to set the reducer
 * @param {function} params.cancelAction - The callback with the cancel action for the cancel button
 * @param {string} params.cancelLabel - The label to place on the cancel button
 * @param {function} params.confirmAction - The callback with the confirm action for the confirm button
 * @param {string} params.confirmLabel - The label to place on the confirm button
 * @param {string} params.messageTranslationKey - The translation key message to display
 * @param {string} params.titleTranslationKey - The title translation key message to display in the smart notification
 * @param {'error' | 'info' | 'success' | 'warning'} params.type - The type of smart notification to display to the user
 */
export const setNotification = (params) => ({
  type: SET_NOTIFICATION,
  payload: params
});

/**
 * Set an Error message on the Smart Notification
 * @param {Object} params Object with the parameters to set the reducer
 * @param {string} params.messageTranslationKey - The translation key message to display
 * @param {string} params.title - The title translation key message to display in the smart notification
 */
export const setErrorNotification = ({ messageTranslationKey, titleTranslationKey }) => ({
  type: SET_NOTIFICATION,
  payload: {
    messageTranslationKey,
    titleTranslationKey,
    type: "error"
  }
});
